module.exports = {"attributes":{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.6439 19.452L13.1439 14.1048L14.1895 13.0293L19.6895 18.3765L18.6439 19.452Z\" fill=\"currentColor\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.77776 15.0379C12.377 15.0379 15.2222 12.2118 15.2222 8.8141C15.2222 5.41636 12.377 2.59033 8.77776 2.59033C5.17848 2.59033 2.33331 5.41636 2.33331 8.8141C2.33331 12.2118 5.17848 15.0379 8.77776 15.0379ZM8.77776 16.5379C13.1654 16.5379 16.7222 13.0798 16.7222 8.8141C16.7222 4.54838 13.1654 1.09033 8.77776 1.09033C4.39016 1.09033 0.833313 4.54838 0.833313 8.8141C0.833313 13.0798 4.39016 16.5379 8.77776 16.5379Z\" fill=\"currentColor\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
